/**
 * Languages that get <link rel="alternate" hreflang=""> tags and sitemap entries.
 * These are the languages you actively target for search traffic.
 * All other 130+ languages are accessible via the language switcher but
 * don't get SEO signals — this avoids diluting crawl budget and avoids
 * Google penalizing thin machine-translated content.
 */
export const SEO_PRIORITY_LOCALES = ['en-US', 'bs-BA'] as const
